import { postRequest, getRequest } from "../api/apiService";

/**
 * Fetch Kutt integration config from the backend.
 */
export const fetchKuttConfig = async () => {
  try {
    const response = await getRequest("/api/kutt/config");
    // getRequest often returns a specific shape, maybe the data directly or response.data.
    // By standard Axios setup, response.data has the payload.
    return response.data;
  } catch (error) {
    console.error("Error fetching Kutt config", error);
    throw error;
  }
};

/**
 * Update Kutt integration config in the backend.
 * @param {Object} config - Configuration object { baseUrl, apiKey, active }
 */
export const updateKuttConfig = async (config) => {
  try {
    const response = await postRequest("/api/kutt/config", config);
    return response.data;
  } catch (error) {
    console.error("Error updating Kutt config", error);
    throw error;
  }
};

/**
 * Fetch available custom domains from Kutt.
 */
export const fetchKuttDomains = async () => {
  try {
    const response = await getRequest("/api/kutt/domains");
    return response.data;
  } catch (error) {
    console.error("Error fetching Kutt domains", error);
    throw error;
  }
};
